import * as types from './siteListActionType';

// Fetch Site List
export const fetchSiteListRequest = (filters = {}) => ({
    type: types.FETCH_SITE_LIST_REQUEST,
    payload: filters
});

export const fetchSiteListSuccess = (data) => ({
    type: types.FETCH_SITE_LIST_SUCCESS,
    payload: data
});

export const fetchSiteListFailure = (error) => ({
    type: types.FETCH_SITE_LIST_FAILURE,
    payload: error
});

// Practice Dropdown Actions
export const fetchPracticeDropdownRequest = () => ({
    type: types.FETCH_PRACTICE_DROPDOWN_REQUEST
});

export const fetchPracticeDropdownSuccess = (data) => ({
    type: types.FETCH_PRACTICE_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchPracticeDropdownFailure = (error) => ({
    type: types.FETCH_PRACTICE_DROPDOWN_FAILURE,
    payload: error
});

// Site Dropdown Actions
export const fetchSiteDropdownRequest = () => ({
    type: types.FETCH_SITE_DROPDOWN_REQUEST
});

export const fetchSiteDropdownSuccess = (data) => ({
    type: types.FETCH_SITE_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchSiteDropdownFailure = (error) => ({
    type: types.FETCH_SITE_DROPDOWN_FAILURE,
    payload: error
});

// Sub Practice Dropdown Actions
export const fetchSubPracticeDropdownRequest = () => ({
    type: types.FETCH_SUB_PRACTICE_DROPDOWN_REQUEST
});

export const fetchSubPracticeDropdownSuccess = (data) => ({
    type: types.FETCH_SUB_PRACTICE_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchSubPracticeDropdownFailure = (error) => ({
    type: types.FETCH_SUB_PRACTICE_DROPDOWN_FAILURE,
    payload: error
});

// Save Bulk Practice Site Actions
export const saveBulkPracticeSiteRequest = (payload) => ({
    type: types.SAVE_BULK_PRACTICE_SITE_REQUEST,
    payload: payload
});

export const saveBulkPracticeSiteSuccess = (data) => ({
    type: types.SAVE_BULK_PRACTICE_SITE_SUCCESS,
    payload: data
});

export const saveBulkPracticeSiteFailure = (error) => ({
    type: types.SAVE_BULK_PRACTICE_SITE_FAILURE,
    payload: error
});
